import React from "react";

export default function AppButton(props: { callback: VoidFunction }) {
  return (
    <button className="button" onClick={props.callback}>
      View Project
    </button>
  );
}
